import React from 'react';
import './sec2-p3.css'
import { supabase } from '../supabase';
import { useEffect } from 'react';
import { useState } from 'react';
import { useRef } from 'react';

const Sec2p3 = () => {

const [ctaa, setctaa]= useState([]);


  useEffect(() => {
  const getcta = async()=>{
      const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;;

  setctaa(res.data);
  }
  getcta();
  }, []);




 const secRef = useRef(null);


useEffect(() => {


  const el = secRef.current;
  if (!el) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        el.classList.remove("in-view");
        void el.offsetHeight;
        el.classList.add("in-view");
      } else {
        el.classList.remove("in-view");
      }
    },
    { threshold: 0.3 }
  );

  observer.observe(el);

  return () => observer.disconnect();

}, []);











    return (
        <section className='sec2-p3' ref={secRef} >
            <section className='container-sec2-p3'>
                <section className='sub-container-sec2-p3'>
                    <button className='large-button-sec2-p3'>
                        <h2 className='text-in-large-button-p3-sec2'>  {ctaa?.[11]?.cta}</h2>
                    </button>

                    <button className='larg-button2-sec2-p3'>
                        <h2 className='text2-in-large-button-p3-sec2'>  {ctaa?.[12]?.cta}</h2>
                    </button>

                    <button className='larg-button2-sec2-p3'>
                        <h2 className='text2-in-large-button-p3-sec2'>  {ctaa?.[13]?.cta}</h2>
                    </button>


                </section>
            </section>
        </section>
      );
}
 
export default Sec2p3;
